import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { ForFacilitatorsPage } from '../../features/marketing/pages/ForFacilitatorsPage';

export const Route = createFileRoute('/$lang/for-facilitators')({ component: Page });

function Page(): ReactNode {
  const { lang } = Route.useParams();
  return <ForFacilitatorsPage lang={lang} />;
}
